"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';

const simpleInputRecipe = tv({
  slots: withSlotScopeClasses("simple-input", {
    row: "transition-colors",
    cell: [
      "focus-within:bg-gray-2",
      "[&:has(.simple-input__input)]:py-[0.35rem]",
      "[&:has(.simple-input__textarea)]:p-0 [&:has(.simple-input__textarea)]:px-3"
    ],
    title: "whitespace-nowrap",
    input: [
      "appearance-none bg-transparent border border-solid border-transparent",
      "h-9 w-full px-4 rounded-md text-black",
      "transition-all duration-100",
      "outline-none focus:outline-none focus-visible:outline-none",
      "disabled:text-neutral-7 disabled:placeholder:text-neutral-7"
    ],
    textarea: "outline-none focus:outline-none focus-visible:outline-none"
  }),
  variants: {
    disabled: {
      true: {
        row: "bg-neutral-1 text-neutral-9"
      }
    }
  }
});

export { simpleInputRecipe };
